module.exports = __webpack_public_path__ + "static/media/comunicado.319525b8.jpg";